// Copyright (c) Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.

import { Component } from '@angular/core';

@Component({
  selector: 'app-convert-component-to-element',
  templateUrl: './convert-component-to-element.component.html',
  styleUrls: ['./convert-component-to-element.component.css', './../app.component.css'],
  standalone: true,
  imports: [],
})
export class ConvertComponentToElementComponent {
  constructor() {}
}
